import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import loaderGif from '../../../assets/loaderForm/loader.gif';
import { useLoaderStyles } from './styles';

const Loader = ({ ...props }) => {
  const { mobile, testId } = props;
  const classes = useLoaderStyles({ mobile });

  return (
    <Box className={classes.container} data-testid={testId}>
      <img className={classes.image} src={loaderGif} alt="imagen de carga" />
    </Box>
  );
};

Loader.propTypes = {
  mobile: PropTypes.bool,
  testId: PropTypes.string,
};

export default Loader;
